<template>
  <b-modal
    ref="infoModal"
    modal-class="action-report-modal"
    centered
    :hide-header-close="true" >
    <template slot="modal-title">
      <div class="flex column">
        <h3>{{ data.title }}</h3>
        <div class="flex flex-align-center" >
          <img
            v-if="data.subtitlePrefixIcon && typeof data.subtitlePrefixIcon === 'string'"
            :src="data.subtitlePrefixIcon"
            style="width: 10px; height: 10px;"
            class="mr-1" >
          <SBIcon
            v-else-if="!data.noSubtitlePrefixIcon"
            class="mr-1"
            :icon="SBIconList.INFO"
            :color="SBColors.greyLight"
            :size="10" />
          <span>{{ data.subtitle }}</span>
        </div>
      </div>
    </template>
    <div v-html="processedMessage" />
    <template slot="modal-footer">
      <b-button @click="hide">
        Close
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';

export default {
  name: 'InfoModal',
  components: {
    SBIcon,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      SBColors,
      SBIconList,
    };
  },
  computed: {
    /**
     * Message can be string or list. In case it is a list it should be transformed into <ul><li> html structure.
     */
    processedMessage() {
      if (this.data.message && Array.isArray(this.data.message)) {
        return `<ul>${this.data.message.map(item => `<li>${item}</li>`).join('')}</ul>`;
      }
      return this.data.message.replace(/\n/g, '<br>');
    },
  },
  methods: {
    show() {
      this.$refs.infoModal.show();
    },
    hide() {
      this.$refs.infoModal.hide();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .modal .modal-dialog .modal-content {
  border-radius: 10px !important;

  .modal-header {
    padding: 18px 15px !important;
    .modal-title {
      h3 {
        font-size: 16px;
        font-weight: 500;
        line-height: 1;
        color: $blackPrimary;
      }
      span {
        margin-top: 5px;
        font-size: 12px;
        font-weight: normal;
        line-height: 1;
        color: $blackUltralight;
      }
    }
  }

  .modal-body {
    padding: 18px 15px !important;
    background: $white !important;
    font-size: 14px;
    font-weight: normal;
    line-height: 1.2;
    color: $blackPrimary;

    ul {
      padding-left: 12px;
      li {
        position: relative;
        &::before {
          content: '-';
          color: $blackPrimary;
          font-size: 14px;
          position: absolute;
          left: -12px;
        }
      }
    }
  }

  .modal-footer {
    padding: 18px 15px !important;

    button {
      border-radius: 10px !important;
      font-size: 14px;
      font-weight: 500;
      line-height: 1.2;
      color: $blackPrimary;
    }
  }
}
</style>
